<template>
  <div :class="`${$style.focusBind}`">
    <div :class="[$style.hint, fullScreen && $style.fullScreen]" v-if="!state">
      <header>
        <span>温馨提示</span>
      </header>
      <main>
          <p v-if="forceBindText">{{ forceBindText }}</p>
          <p v-else-if="forceBindTel == 3">
            亲爱的游戏玩家，根据文化部
            <span>《网络游戏管理暂行办法》</span>的有关要求，从明天开始本游戏将无法为未经实名认证的玩家提供服务，请您尽快前往认证，感谢您的配合，祝您游戏愉快。
          </p>
          <p v-else>
            亲爱的游戏玩家，根据文化部
            <span>《网络游戏管理暂行办法》</span>的有关要求及您的个人权益保障，网络游戏用户需要进行实名认证，确保安全登录游戏。请您尽快进行手机号绑定，以免造成无法正常登陆游戏的情况，感谢您的配合，祝您游戏愉快
            的有关要求及您的个人权益保障，网络游戏用户需要进行实名认证，确保安全登录游戏。请您尽快进行手机号绑定，以免造成无法正常登陆游戏的情况，感谢您的配合，祝您游戏愉快的有关要求及您的个人权益保障，网络游戏用户需要进行实名认证，确保安全登录游戏。请您尽快进行手机号绑定，以免造成无法正常登陆游戏的情况，感谢您的配合，祝您游戏愉快的有关要求及您的个人权益保障，网络游戏用户需要进行实名认证，确保安全登录游戏。请您尽快进行手机号绑定，以免造成无法正常登陆游戏的情况，感谢您的配合，祝您游戏愉快的有关要求及您的个人权益保障，网络游戏用户需要进行实名认证，确保安全登录游戏。请您尽快进行手机号绑定，以免造成无法正常登陆游戏的情况，感谢您的配合，祝您游戏愉快的有关要求及您的个人权益保障，网络游戏用户需要进行实名认证，确保安全登录游戏。请您尽快进行手机号绑定，以免造成无法正常登陆游戏的情况，感谢您的配合，祝您游戏愉快的有关要求及您的个人权益保障，网络游戏用户需要进行实名认证，确保安全登录游戏。请您尽快进行手机号绑定，以免造成无法正常登陆游戏的情况，感谢您的配合，祝您游戏愉快
          </p>
        <div :class="$style.btnGroup">
          <button :class="$style.btnCancel" @click="close()">取消</button>
          <button :class="$style.btnConfirm" @click="confirm">确认绑定</button>
        </div>
      </main>
    </div>
    <BindPhone :normalTelBind="normalTelBind" @back="closeBindPhone" :isH5="isH5" v-else></BindPhone>
  </div>
</template>

<script>
import BindPhone from '../BindPhone';
import { mapState } from 'vuex';
import isFullScreen from '@/libs/business/fullScreen'

export default {
  name: '',
  props: ['isH5', 'normalTelBind'],
  data() {
    return {
      state: 0,
      topImg: `${this.$cdnLink}/skins/blue.png`,
      fullScreen: ''
    };
  },
  created() {
    this.fullScreen = isFullScreen();
    if (this.normalTelBind) {
      this.state = 1;
    }
  },
  mounted() {
    document.body.addEventListener('touchstart', function () { });
  },
  computed: {
    ...mapState({
      forceBindTel: state => state.user.force_bind_tel,
      forceBindText: state => state.user.force_bind_text
    })
  },
  components: {
    BindPhone
  },
  methods: {
    close(type) {
      this.$emit('close');
    },
    closeBindPhone(type) {
      if (!type && !this.normalTelBind) {
        this.state = 0;
      } else {
        this.$emit('close', type);
      }
    },
    confirm() {
      this.state = 1;
    }
  }
};
</script>

<style lang="scss" module>
@import "../../../assets/css/common.scss";

.focusBind {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  z-index: $force-bind;
  .hint {
    @include common-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
    }
    > main {
      padding-top: 0.25rem;
      padding-bottom: 0.3rem;
      > p {
        text-align: left;
        word-wrap: break-word;
        text-indent: 2em;
        font-size: 0.24rem;
        line-height: 0.28rem;
        padding: 0 0.3rem;
        color: #585858;
        height: 2.8rem;
        overflow: auto;
        > span {
          color: #db8424;
        }
      }
      .btnGroup {
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 0.2rem;
        width: 100%;
        > button {
          width: 2.2rem;
          height: 0.6rem;
          border: none;
          outline: none;
          background: none;
          font-size: 0.24rem;
          border-radius: 0.66rem;
          margin: 0 0.1rem;
          &:active {
            -webkit-filter: brightness(110%);
            filter: brightness(110%);
          }
        }
        .btnCancel {
          border: 1px solid $primary-color;
          color: $primary-color;
        }
        .btnConfirm {
          background: $primary-color;
          color: #ffffff;
        }
      }
    }
    &.fullScreen {
      @include full-screen-window();
      > header {
        position: relative;
        > span {
          font-weight: 600;
          font-style: italic;
        }
      }
      > main {
        padding-top: 12px;
        padding-bottom: 15px;
        > p {
          text-align: left;
          word-wrap: break-word;
          text-indent: 2em;
          font-size: 12px;
          line-height: 14px;
          padding: 0 15px;
          color: #585858;
          height: 140px;
          overflow: auto;
          > span {
            color: #db8424;
          }
        }
        .btnGroup {
          display: flex;
          justify-content: center;
          position: absolute;
          bottom: 10px;
          width: 100%;
          > button {
            width: 110px;
            height: 30px;
            border: none;
            outline: none;
            background: none;
            font-size: 12px;
            border-radius: 33px;
            margin: 0 5px;
            &:active {
              -webkit-filter: brightness(110%);
              filter: brightness(110%);
            }
          }
          .btnCancel {
            border: 1px solid $primary-color;
            color: $primary-color;
          }
          .btnConfirm {
            background: $primary-color;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>